import { render, staticRenderFns } from "./remarkStandard.vue?vue&type=template&id=b50895fa&scoped=true"
import script from "./remarkStandard.vue?vue&type=script&lang=js"
export * from "./remarkStandard.vue?vue&type=script&lang=js"
import style0 from "./remarkStandard.vue?vue&type=style&index=0&id=b50895fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b50895fa",
  null
  
)

export default component.exports